export class Slug {
	fullText;

	constructor(fullText) {
		this.fullText = fullText;
	}

	toString() {
		let slug = this.fullText.toLowerCase();
		const stripChars = ["'", '"', ",", ".", "!", "?", "$", "£", "#", "@", "+", "(", ")", "*", "&", "^", "%", "<", ">", "/", "\\", "|"];
		slug = slug.replace(new RegExp(`[${stripChars.join("")}]`, "g"), "");
		slug = slug.replace(/([^A-Za-z0-9]+)|(---)/g, "-");
		return slug.replace(/\s/g, "-");
	}
}
